import React from 'react';
import PropTypes from 'prop-types';
import {
    Snackbar as MaterialSnackbar,
    Typography,
} from '@material-ui/core';
import SnackbarVariant from './component/SnackbarVariant';
import { ON_CLOSE_REASON_CLICKAWAY } from './constants';

function Snackbar({
    open,
    message,
    variant,
    anchorOrigin,
    autoHideDuration,
    onClose,
    secondaryMessages,
}) {
    if (message === null || variant === null) {
        return null;
    }

    const notificationMessage = (
        <span>
            {message}
            {secondaryMessages ? (
                <React.Fragment>
                    <br />
                    <br />
                    {secondaryMessages.map((text, key) => <Typography variant="body2" key={key}>{text}</Typography>)}
                </React.Fragment>
            ) : null}
        </span>
    );

    const closeSnackbar = (event, reason) => {
        if (reason === ON_CLOSE_REASON_CLICKAWAY) {
            return;
        }

        onClose();
    };

    return (
        <MaterialSnackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={closeSnackbar}
            anchorOrigin={anchorOrigin}
        >
            <SnackbarVariant onClose={closeSnackbar} message={notificationMessage} variant={variant} />
        </MaterialSnackbar>
    );
}

Snackbar.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    message: PropTypes.string,
    autoHideDuration: PropTypes.number,
    variant: PropTypes.string,
    secondaryMessages: PropTypes.arrayOf(PropTypes.string),
    anchorOrigin: PropTypes.shape({
        vertical: PropTypes.string,
        horizontal: PropTypes.string,
    }),
};

Snackbar.defaultProps = {
    message: null,
    autoHideDuration: 6000,
    variant: null,
    anchorOrigin: { vertical: 'top', horizontal: 'center' },
    secondaryMessages: null,
};

export default React.memo(Snackbar);
